var exports = {
  "PH": "confirmIconOuter__1QGLlw",
  "wM": "confirmIconInner__1VWvpo",
  "OQ": "ctaContainer__9pHP6D",
  "nV": "relatedResources__cKcZlO",
};

module.exports = exports;
